import React from "react";
import logo from "../Assets/Images/logo.png";
import TopArrow from "../Assets/Icon/TopArrow";
const Home = ({ setShowNew, showNew }) => {
  return (
    <div
      className={`fixed w-screen h-screen top-0 left-0 bg-white z-30 flex flex-col items-center justify-center gap-2 text-center transition-all ${
        showNew ? "-top-1/4 opacity-0 pointer-events-none" : "top-0 opacity-100"
      }`}
    >
      <img src={logo} alt="waratel logo" className=" w-32" />
      <p className=" text-2xl">أهلا بكم في منصة ورتل القرآنية</p>
      <button
        className=" mt-12 flex flex-col items-center gap-2 hover:opacity-70 transition-all"
        onClick={() => {
          setShowNew(true);
          localStorage.oldVist = true;
        }}
      >
        <TopArrow />
        <span className="text-white bg-[var(--MColor)] py-2 px-4 rounded-2xl ">
          تصفح الآن
        </span>
      </button>
    </div>
  );
};

export default Home;
